import { useState } from 'react';
import Reveal from '../components/Reveal';
import { BLOG_POSTS } from '../data';

const CATEGORIES = ['All', 'Meta Ads', 'Google Ads', 'Social Media', 'Branding', 'Strategy', 'Performance'];

export default function Blog({ openForm }) {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [activeCategory, setActiveCategory] = useState('All');

  const filtered = activeCategory === 'All' ? BLOG_POSTS : BLOG_POSTS.filter(p => p.cat === activeCategory);

  return (
    <div style={{ paddingTop: 90 }}>
      <section className="section">
        <div className="container">
          <Reveal>
            <span className="tag">Blog & Insights</span>
            <h1 style={{ fontFamily: 'var(--fD)', fontSize: 'clamp(30px,5vw,58px)', fontWeight: 900, marginBottom: 16 }}>
              Real estate digital<br />marketing insights.
            </h1>
            <p style={{ color: 'var(--mut)', fontSize: 17, maxWidth: 480, lineHeight: 1.8, marginBottom: 48 }}>
              Actionable strategies, campaign insights, and industry updates from our team of real estate marketing specialists.
            </p>
          </Reveal>

          {/* Newsletter strip */}
          <Reveal>
            <div style={{ background: 'linear-gradient(135deg,rgba(0,229,204,0.07),rgba(255,107,53,0.05))', border: '1px solid rgba(0,229,204,0.15)', borderRadius: 18, padding: '32px 36px', marginBottom: 48, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 28, flexWrap: 'wrap' }}>
              <div>
                <h3 style={{ fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 20, marginBottom: 6 }}>Weekly Marketing Digest</h3>
                <p style={{ color: 'var(--mut)', fontSize: 14 }}>Actionable insights from active campaigns. Free, every week.</p>
              </div>
              {subscribed ? (
                <div style={{ color: 'var(--acc)', fontWeight: 700 }}>✓ You're subscribed!</div>
              ) : (
                <div style={{ display: 'flex', gap: 10, flex: 1, minWidth: 260, maxWidth: 400 }}>
                  <input
                    placeholder="your@email.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    style={{ flex: 1, padding: '11px 14px', background: 'var(--surf)', border: '1px solid var(--bdr)', borderRadius: 9, color: 'var(--txt)', fontSize: 14, outline: 'none', fontFamily: 'var(--fB)' }}
                  />
                  <button onClick={() => email && setSubscribed(true)} className="btn btn-teal" style={{ padding: '11px 18px', fontSize: 14 }}>
                    Subscribe →
                  </button>
                </div>
              )}
            </div>
          </Reveal>

          {/* Category filter */}
          <Reveal>
            <div style={{ display: 'flex', gap: 8, marginBottom: 40, flexWrap: 'wrap' }}>
              {CATEGORIES.map(cat => (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  style={{
                    padding: '8px 16px', borderRadius: 100,
                    background: activeCategory === cat ? 'var(--acc)' : 'var(--surf)',
                    border: `1px solid ${activeCategory === cat ? 'var(--acc)' : 'var(--bdr)'}`,
                    color: activeCategory === cat ? '#060912' : 'var(--mut)',
                    fontFamily: 'var(--fB)', fontWeight: 600, fontSize: 12,
                    cursor: 'pointer', transition: 'all 0.2s',
                  }}
                >
                  {cat}
                </button>
              ))}
            </div>
          </Reveal>

          {/* Posts grid */}
          <div className="grid-3">
            {filtered.map((post, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="card" style={{ padding: 0, overflow: 'hidden', cursor: 'pointer' }}>
                  <div style={{ height: 5, background: post.color }} />
                  <div style={{ padding: '26px 28px' }}>
                    <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center', flexWrap: 'wrap' }}>
                      <span style={{ fontSize: 10, background: `${post.color}18`, color: post.color, border: `1px solid ${post.color}30`, padding: '3px 11px', borderRadius: 100, fontWeight: 700 }}>{post.cat}</span>
                      <span style={{ color: 'var(--mut)', fontSize: 12 }}>{post.date}</span>
                      <span style={{ color: 'var(--mut)', fontSize: 12, marginLeft: 'auto' }}>⏱ {post.read}</span>
                    </div>
                    <h2 style={{ fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 20, lineHeight: 1.25, marginBottom: 12 }}>{post.title}</h2>
                    <p style={{ color: 'var(--mut)', fontSize: 14, lineHeight: 1.75, marginBottom: 20 }}>{post.excerpt}</p>
                    <span style={{ color: post.color, fontWeight: 600, fontSize: 14 }}>Read Article →</span>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          {/* CTA */}
          <Reveal>
            <div style={{ textAlign: 'center', marginTop: 64, padding: '48px', background: 'var(--surf)', border: '1px solid var(--bdr)', borderRadius: 22 }}>
              <h3 style={{ fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 28, marginBottom: 12 }}>Want a custom strategy for your project?</h3>
              <p style={{ color: 'var(--mut)', fontSize: 16, maxWidth: 400, margin: '0 auto 28px', lineHeight: 1.75 }}>
                Skip the reading and get a personalised marketing plan from our team — free.
              </p>
              <button onClick={openForm} className="btn btn-teal" style={{ fontSize: 16, padding: '14px 30px' }}>Get Free Consultation →</button>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
